
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"repositoryRunCheckDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"checkId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"check"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"checkId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"checkId"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"filesAffectedByAutofix"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"errorsRendered"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isRetryable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"autofixableIssues"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"shortcode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"category"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"occurrenceCount"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"run"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isForDefaultBranch"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isForCrossRepoPr"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"analyzer"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shortcode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"analyzerLogo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"analyzerType"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"metricsCaptured"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"shortcode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"valueDisplay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"valueTrendDisplay"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isPassing"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"extraData"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"namespace"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"threshold"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isSuppressed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"trendPositive"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":640}};
    doc.loc.source = {"body":"query repositoryRunCheckDetails($checkId: ID!) {\n  check(checkId: $checkId) {\n    id\n    status\n    filesAffectedByAutofix\n    errorsRendered\n    isRetryable\n    autofixableIssues {\n      shortcode\n      title\n      category\n      occurrenceCount\n    }\n    run {\n      id\n      isForDefaultBranch\n      isForCrossRepoPr\n    }\n    analyzer {\n      name\n      shortcode\n      analyzerLogo\n      analyzerType\n    }\n    metricsCaptured {\n      id\n      name\n      shortcode\n      value\n      valueDisplay\n      valueTrendDisplay\n      isPassing\n      extraData\n      namespace\n      threshold\n      isSuppressed\n      trendPositive\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["repositoryRunCheckDetails"] = oneQuery(doc, "repositoryRunCheckDetails");
        
